import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AjaxService } from "src/app/service/ajax.service";
import { UtilService } from "src/app/service/util.service";
import { API } from "src/environments/environment";

@Component({
  selector: "app-modal-cadastro-diario",
  templateUrl: "./modal-cadastro-diario.component.html",
  styleUrls: ["./modal-cadastro-diario.component.scss"],
})
export class ModalCadastroDiarioComponent implements OnInit {
  @Output() acaoVoltar = new EventEmitter();
  @Input() item: any;

  public pergunta: string;
  public tipo: string;
  public descricao: string;
  public peso: number;

  public perguntaOpcao: string;
  public confirmacaoInstrucao: string;
  public opcoes: any[];
  public opcoesConfirmacaoInstrucao: [];

  public qtdRespostas: number;
  public porcAcertos: number;
  public maxDiasResposta: number;
  public aplicarRegra: boolean;
  public campoLivre: string;
  public observacao: string;

  public arrayProgramas: any[];
  public programaSelecionado: any;

  constructor(private ajax: AjaxService, public util: UtilService) {}

  ngOnInit() {
    this.limpar();
    this.buscarProgramas();
  }

  ngOnChanges() {
    this.preencheModuloEdit(this.item);
  }

  preencheModuloEdit(item) {
    console.log("dentro do modal");
    debugger;
    if (item != null) {
      this.pergunta = item.pergunta;
      this.descricao = item.descricao;
      this.confirmacaoInstrucao = item.confirmacaoInstrucao;
      this.tipo = item.tipo;
      this.opcoes = item.opcoes;
      this.qtdRespostas = item.qtD_RESPOSTAS || item.qTd_RESPOSTAS || item.qtdRespostas || 0;
      this.porcAcertos = item.porC_ACERTOS || item.pORC_ACERTOS || item.porcAcertos || 0;
      this.maxDiasResposta = item.maX_DIAS_RESPOSTA || item.mAX_DIAS_RESPOSTA || item.maxDiasResposta || 0;
      this.aplicarRegra = item.aplicaR_REGRA != null ? item.aplicaR_REGRA : (item.aPLICAR_REGRA != null ? item.aPLICAR_REGRA : (item.aplicarRegra != null ? item.aplicarRegra : false));
      this.campoLivre = item.campO_LIVRE || item.cAMPO_LIVRE || item.campoLivre || "";
      this.observacao = item.obSERVACAO || item.oBSERVACAO || item.observacao || "";
      this.programaSelecionado = item.iD_PROGRAMA || item.programaSelecionado || null;
    } else {
      this.limpar();
    }
  }

  limpar() {
    this.pergunta = "";
    this.tipo = "M";
    this.descricao = "";
    this.peso = 0;

    this.perguntaOpcao = "";
    this.confirmacaoInstrucao = "";
    this.opcoes = [];
    this.opcoesConfirmacaoInstrucao = [];
    this.item = null;
    this.qtdRespostas = 0;
    this.porcAcertos = 0;
    this.maxDiasResposta = 0;
    this.aplicarRegra = false;
    this.campoLivre = "";
    this.observacao = "";
    this.programaSelecionado = null;
    this.limparLinha();
  }

  mudarTipo() {
    this.limparLinha();
    this.opcoes = [];
  }

  validar(): boolean {
    if (this.pergunta == undefined || this.pergunta == "") {
      this.util.toasterShowError("Atenção", "Entre com o pergunta do diário");
      return false;
    }

    if (this.opcoes.length == 0) {
      this.util.toasterShowError("Atenção", "Entre com pelo menos uma opção");
      return false;
    }

    if (this.peso == null) {
      this.util.toasterShowError("Atenção", "Entre com um valor de peso válido");
      return false;
    }

    return true;
  }

  addLinha() {
    debugger
    let linha = {
      perguntaOpcao: this.perguntaOpcao,
      peso:  this.peso
    };

    if (this.tipo == "P") {
      linha["confirmacaoInstrucao"] = this.confirmacaoInstrucao;
      linha["opcoesConfirmacaoInstrucao"] = this.opcoesConfirmacaoInstrucao;
    }

    this.opcoes.push(linha);
    this.limparLinha();
  }

  limparLinha() {
    this.perguntaOpcao = "";
    this.peso = 0;
    this.confirmacaoInstrucao = "";
    this.opcoesConfirmacaoInstrucao = [];
  }

  removeOpcaoColuna(index) {
    this.opcoes.splice(index, 1);
  }

  montarJson() {
    var dados = {
      PERGUNTA: this.pergunta,
      DESCRICAO: this.descricao,
      TIPO: this.tipo,
      QTD_RESPOSTAS: this.qtdRespostas || 0,
      PORC_ACERTOS: this.porcAcertos || 0,
      MAX_DIAS_RESPOSTA: this.maxDiasResposta || 0,
      APLICAR_REGRA: this.aplicarRegra || false,
      CAMPO_LIVRE: this.campoLivre || "",
      OBSERVACAO: this.observacao || "",
      ID_PROGRAMA: this.programaSelecionado || null
    };

    if(this.item != null)
      dados["ID_DIARIO"] = this.item.iD_DIARIO

    dados["OPCOES"] = this.opcoes;

    return dados;
  }

  salvar() {
    debugger;
    if (this.validar()) {
      let dados = this.montarJson();
      console.log(dados);
      let url = API + "Diario/Diario/salvar";
      this.ajax.post(url, dados).subscribe(
        (response) => {
          this.util.closeLoading();
          if (!response.hasErrors) {
            this.util.toasterShowSuccess("Atenção", "Módulo Salvo com Sucesso");
            this.limpar();
            this.voltar();
          } else {
            this.util.toasterShowError("Atenção", response.message);
          }
        },
        (err) => {
          debugger;
          this.util.closeLoading();
          this.util.toasterShowError("Atenção", "Erro ao Salvar Módulo");
        }
      );
    }
  }

  alterar() {
    if (this.validar()) {
      debugger
      let dados = this.montarJson();
      let url = API + "Diario/Diario/editar";
      this.ajax.post(url, dados).subscribe(
        (response) => {
          this.util.closeLoading();
          if (!response.hasErrors) {
            this.util.toasterShowSuccess("Atenção", "Módulo Salvo com Sucesso");
            this.limpar();
            this.voltar();
          } else {
            this.util.toasterShowError("Atenção", response.message);
          }
        },
        (err) => {
          debugger;
          this.util.closeLoading();
          this.util.toasterShowError("Atenção", "Erro ao Salvar Módulo");
        }
      );
    }
  }

  voltar() {
    this.acaoVoltar.emit();
  }

  buscarProgramas() {
    this.util.showLoading();
    let url = API + "Programa/Programa";
    return this.ajax.get(url)
      .subscribe(response => {
        this.arrayProgramas = this.util.convertIoptions(response.data, "iD_PROGRAMA", "descricao");
        this.util.closeLoading();
      }, err => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Buscar Programas");
      });
  }
}
